export default __webpack_public_path__ + "static/4-contactus-470ea2b194a5ae2ecfc72cd0c9bcff0c.jpg";